import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { ScreenState } from '../enums/sceen-state.enum';

@Injectable({
  providedIn: 'root'
})
export class ScreenStateService {
  private ngUnsubscribe = new Subject<void>();
  private _screenState: BehaviorSubject<ScreenState> = new BehaviorSubject<ScreenState>(ScreenState.Desktop);
  public screenState$ = this._screenState.asObservable();
  
  public isMobile() {
    return this._screenState.value === ScreenState.Mobile;
  }

  public isTablet() {
    return this._screenState.value === ScreenState.Tablet;
  }

  public isDesktop() {
    return this._screenState.value === ScreenState.Desktop;
  }

  constructor(
    private readonly breakpointObserver: BreakpointObserver
  ) {
    this.observeScreenSizeChanges();
  }

  private observeScreenSizeChanges() {
    this.breakpointObserver
      .observe(Object.values(ScreenState))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {
        const isTablet = result.breakpoints[ScreenState.Tablet];
        const isDesktop = result.breakpoints[ScreenState.Desktop];
        this._screenState.next(isDesktop ? ScreenState.Desktop : isTablet ? ScreenState.Tablet : ScreenState.Mobile);
      });
  }
}
